import { useNavigate, useParams } from "react-router-dom";
import { Card, CardContent, Box } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title } from "chart.js";
import MDTypography from "@mui/material/Typography";
import MDButton from "components/MDButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title);

export default function WarehouseDetailsPage() {
  const { warehouseId } = useParams();

  // hardcoded zone data
  const zoneData = {
    WH01: [
      { zone: "Zone 1", filled: 50, empty: 10 },
      { zone: "Zone 2", filled: 30, empty: 5 },
      { zone: "Zone 3", filled: 40, empty: 15 },
      { zone: "Zone 4", filled: 60, empty: 20 },
      { zone: "Zone 5", filled: 70, empty: 35 },
      { zone: "Zone 6", filled: 80, empty: 55 },
      { zone: "Zone 7", filled: 50, empty: 10 },
      { zone: "Zone 8", filled: 30, empty: 5 },
      { zone: "Zone 9", filled: 40, empty: 15 },
      { zone: "Zone 10", filled: 60, empty: 20 },
      { zone: "ZoneE 11", filled: 70, empty: 35 },
      { zone: "Zone 12", filled: 80, empty: 55 },
    ],
    WH02: [
      { zone: "Zone 1", filled: 60, empty: 20 },
      { zone: "Zone 2", filled: 20, empty: 10 },
      { zone: "Zone 3 ", filled: 10, empty: 5 },
      { zone: "Zone 4", filled: 60, empty: 20 },
      { zone: "Zone 5", filled: 70, empty: 35 },
      { zone: "Zone 6", filled: 80, empty: 55 },
      { zone: "Zone 7", filled: 50, empty: 10 },
      { zone: "Zone 8", filled: 30, empty: 5 },
      { zone: "Zone 9", filled: 40, empty: 15 },
      { zone: "Zone 10", filled: 60, empty: 20 },
      { zone: "ZoneE 11", filled: 70, empty: 35 },
      { zone: "Zone 12", filled: 80, empty: 55 },
      { zone: "Zone 13", filled: 80, empty: 55 },
    //   { zone: "Zone 14", filled: 50, empty: 10 },
    //   { zone: "Zone 15", filled: 30, empty: 5 },
    //   { zone: "Zone 16", filled: 40, empty: 15 },
    //   { zone: "Zone 17", filled: 60, empty: 20 },
    //   { zone: "ZoneE 18", filled: 70, empty: 35 },
    //   { zone: "Zone 19", filled: 80, empty: 55 },
    ],
  };
const navigate = useNavigate();
  const data = zoneData[warehouseId] || [];

  const chartData = {
    labels: data.map((z) => z.zone),
    datasets: [
      {
        label: "Filled",
        data: data.map((z) => z.filled),
        backgroundColor: "rgba(75, 192, 192, 0.4)",
      },
      {
        label: "Empty",
        data: data.map((z) => z.empty),
        backgroundColor: "rgba(153, 102, 255, 0.4)",
      },
    ],
  };
return (
  <Box sx={{ marginLeft: "20rem",marginTop: "6rem", marginRight: 4 }}>
    <Card sx={{ boxShadow: 3 }}>
      <CardContent>
        <MDTypography variant="h5" gutterBottom>
          Zones in {warehouseId}
        </MDTypography>
        <Box sx={{ minWidth: `${chartData.labels.length * 60}px` }}>
          <Bar
            data={chartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                x: { stacked: true },
                y: { stacked: true },
              },
            }}
            height={600}
          />
        </Box>
      <MDButton
  variant="contained"
  color="primary"
  onClick={() => navigate(-1)}
  sx={{ borderRadius: 2, minWidth: 40, height: 40 }}
>
  <ArrowBackIcon />
</MDButton>

      </CardContent>
    </Card>
  </Box>
);

}
